import detailApiCall from './itemDetail'
import portfolioApiCall from './portfolio'

const ApiCall = {
  itemDetail: detailApiCall,
  portfolio: portfolioApiCall
}

export default ApiCall
